import type { AlibabaModelConfig, InputPayloadType } from './types';
import { alibabaModelConfigs } from './config';

/**
 * 获取模型配置
 */
export function getAlibabaModelConfig(modelId: string): AlibabaModelConfig {
    const config = alibabaModelConfigs[modelId];
    if (!config) {
        throw new Error(`Model ${modelId} not found`);
    }
    return config;
}

/**
 * 构建输入参数
 */
export async function buildInputPayloadFromConfig(
    modelId: string,
    params: {
        prompt: string;
        imagePrompt?: string[];
        videoUri?: string;
        videoUris?: string[];
        audioUri?: string;
        audioUris?: string[];
        duration: number;
        aspectRatio?: string;
        quality?: string;
        modelUi?: Record<string, any>;
        providerOptions?: Record<string, Record<string, any>>;
    }
): Promise<InputPayloadType> {
    // 获取服务商配置
    const config = getAlibabaModelConfig(modelId);

    // 构建输入参数
    const result = await config.buildInput(params);

    return result;
}